import { useState, useEffect } from 'react';

const useMobileDetect = (): boolean => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const match = window.matchMedia('(max-width: 768px)');
      setIsMobile(match.matches);
    };

    // Первоначальная проверка
    checkMobile();
    
    // Слушатель изменений размера окна
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return isMobile;
};

export default useMobileDetect; 